"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToasts = exports.ToastsProvider = exports.context = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const ToastService_1 = require("./services/ToastService");
exports.context = React.createContext(new ToastService_1.ToastService());
const ToastsProvider = ({ value, children }) => {
    const value2 = React.useMemo(() => value ?? new ToastService_1.ToastService(), [value]);
    return React.createElement(exports.context.Provider, { value: value2 }, children);
};
exports.ToastsProvider = ToastsProvider;
const useToasts = () => React.useContext(exports.context);
exports.useToasts = useToasts;
